/**
 * Global imports
 */
import svg4everybody from 'svg4everybody';
import MobileMenu from './components/mobile-menu';
import restrictInput from './components/restrict-input';
import startSlideshow from './components/slideshow';
import showJobs from './components/show-jobs';
import footer from './components/footer';
import productSlider from './components/products-slider';
import relatedSlider from './components/related';
import team from './components/team';
import { casesMapModule } from './blocks/casesMap';
import { guaranteesMapModule } from './blocks/guaranteesMap';
import partialsMap from './components/partialsMap';
import historyModule from './blocks/history';
import megaMenu from './global/megaMenu';
import Hero from './blocks/hero';
import SiteLine from './components/siteLine';
import header from './global/header';
import charts from './blocks/charts';
import { casesArchive } from './blocks/casesArchive';
import { newsArchive } from './blocks/newsArchive';
import { messagesArchive } from './blocks/messagesArchive';
import accordionEvent from './components/accordionEvent';
import { cases } from './blocks/cases';
import { guarantees } from './blocks/guarantees';
import caseIntro from './blocks/caseIntro';
import faqArchive from './blocks/faqArchive';
import faqVideosModule from './blocks/faqVideos';
import newsGuarantee from './blocks/newsGuarantee';
import reportHeader from './components/report-header';
import passwordOverlay from './components/passwordOverlay';

document.addEventListener('DOMContentLoaded', () => {
    svg4everybody();
    MobileMenu();
    restrictInput();
    startSlideshow();
    showJobs();
    footer();
    productSlider();
    relatedSlider();
    team();
    megaMenu();
    Hero();
    SiteLine();
    header();
    accordionEvent();
    
    // Only initialize cases if the block is present
    if (document.querySelector('section.cases-map')) {
        cases();
    }
    
    // Only initialize guarantees if the block is present
    if (document.querySelector('section.guarantees')) {
        guarantees();
    }
    
    caseIntro();

    if (document.querySelector('section.cases-map')) {
        casesMapModule();
    }

    if (document.querySelector('section.guarantees')) {
        guaranteesMapModule();
    }

    if (document.querySelector('.js-partials--map')) {
        partialsMap();
    }

    if (document.querySelector('section.history')) {
        historyModule();
    }

    if (document.querySelector('section.charts')) {
        charts();
    }

    if (document.querySelector('.cases-archive')) {
        casesArchive();
    }

    if (document.querySelector('.news-archive')) {
        newsArchive();
    }
    
    newsGuarantee();

    if (document.querySelector('.faq')) {
        faqArchive();
    }

    if (document.querySelector('section.faq-videos')) {
        faqVideosModule();
    }

    if (document.querySelector('.messages-archive')) {
        messagesArchive();
    }

    if (document.querySelector('.report-header')) {
        reportHeader();
    }

    if (document.querySelector('.password-overlay')) {
        passwordOverlay();
    }
});
